import {AccountLinkingCardTypeEnum} from './account-card-type';
import * as styles from './account-card.scss';

export const accountLinkingCardStyleMap: Record<AccountLinkingCardTypeEnum, string> = {
    [AccountLinkingCardTypeEnum.LINKED]: styles.account_card__linked,
    [AccountLinkingCardTypeEnum.DEFAULT]: styles.account_card__default,
    [AccountLinkingCardTypeEnum.ERROR]: styles.account_card__error,
};
